// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * useUniverseValidation Hook
 * 
 * React hook for runtime universe validation.
 * Validates universe when entering and logs issues for later analysis.
 * 
 * Usage:
 *   const { validateOnEnter, getLog, clearLog } = useUniverseValidation();
 *   
 *   // When switching universes
 *   const result = validateOnEnter(newUniverse, allUniverses);
 *   if (!result.valid) {
 *     console.warn('Universe has issues:', result.issues);
 *   }
 */

import { useCallback } from 'react';
import { validateUniverseOnEnter, getValidationLog, clearValidationLog } from '../utils/UniverseManager';

export function useUniverseValidation() {
  const validateOnEnter = useCallback((universe, allUniverses) => {
    return validateUniverseOnEnter(universe, allUniverses);
  }, []);

  const getLog = useCallback(() => {
    return getValidationLog();
  }, []);

  const clearLog = useCallback(() => {
    clearValidationLog();
  }, []);

  return {
    validateOnEnter,
    getLog,
    clearLog
  };
}

export default useUniverseValidation;
